import { PortalAPI } from "../infrastructure/portalApi";

// The therapist's tools as the patient meets them: booking, payments,
// WhatsApp consent, and what was shared (systemic maps, meditations). Whether
// each one shows at all is the server's call.

// --- Booking ---------------------------------------------------------------

export async function getBookingAvailability() {
  const { data } = await PortalAPI.getBookingAvailability();
  return data;
}

export async function listBookingSlots(date: string) {
  const { data } = await PortalAPI.getBookingSlots(date);
  return data;
}

export async function bookPortalSession(start: string) {
  const { data } = await PortalAPI.bookSession(start);
  return data;
}

// --- Payments --------------------------------------------------------------

export async function getPaymentsAvailability() {
  const { data } = await PortalAPI.getPaymentsAvailability();
  return data;
}

export async function listPortalPayments() {
  const { data } = await PortalAPI.getPayments();
  return data;
}

// --- WhatsApp --------------------------------------------------------------

export async function getWhatsAppPreference() {
  const { data } = await PortalAPI.getWhatsAppPreference();
  return data;
}

export async function setWhatsAppPreference(optIn: boolean) {
  const { data } = await PortalAPI.setWhatsAppPreference(optIn);
  return data;
}

// --- Shared maps and meditations -------------------------------------------

export async function listPortalSystemicMaps() {
  const { data } = await PortalAPI.getSystemicMaps();
  return data;
}

export async function getPortalSystemicMap(mapId: string) {
  const { data } = await PortalAPI.getSystemicMap(mapId);
  return data;
}

export async function listPortalMeditations() {
  const { data } = await PortalAPI.getMeditations();
  return data;
}

export async function getPortalMeditation(meditationId: string) {
  const { data } = await PortalAPI.getMeditation(meditationId);
  return data;
}

export async function getMeditationAudio(meditationId: string) {
  const { data } = await PortalAPI.getMeditationAudio(meditationId);
  return data;
}

export async function getMeditationBackgroundAudio(meditationId: string) {
  const { data } = await PortalAPI.getMeditationBackgroundAudio(meditationId);
  return data;
}
